import React from "react";
import {observer} from "mobx-react";
import "./index.css";
import StoreFocus from "../../focus/StoreFocus";
import {FOCUS_LAYER__MENU, MENU_MODE__NETWORK} from "../../common/const";
import focusable from "../../focus/Focusable";
import i18n from "../../common/i18n";
import StoreSounds from "../../store/StoreSounds";
import StoreApp from "../../store/StoreApp";
import {showExitConfirm} from "../popupmessage/PopupMessage";

const ItemExit = focusable(observer(class ItemExit extends React.Component {


    onCLick = () => {

        if(!StoreApp.clicksEnabled)    return;

        if(StoreFocus.currentFocusLayer !== FOCUS_LAYER__MENU) return;

        StoreSounds.playPls('click');

        showExitConfirm();
        /*StoreApp.showBadgePopupMessage([
            {
                id: "pervoe_slovo",
                count: 1
            },
            {
                id: "pervaya_pobeda",
                count: 2,
            }
        ]);*/
    }

    render() {
        //console.log('render ItemExit');

        let className = StoreApp.menuMode === MENU_MODE__NETWORK ? '' : 'focusable ';

        if(this.props.focused) className += ' focused';

        return (<li className={className} onClick={this.onCLick}>{i18n.mainMenu.exit}</li>);
    }
}))

export default ItemExit;